

























































































































































































































import BaseComponent from '@/core/base.component';
import { ArticleDto } from '@/dto';
import ArticleService from '../../../services/article.service';
import Component from 'vue-class-component';
import { ArticleUpdateDto } from '@/dto';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';

import toast from '../../../../resources/assets/js/services/toast.js';
import { CONST_YN, YN } from '@/common';

@Component({
  name: 'ArticleDetail',
})
export default class ArticleDetail extends BaseComponent {
  private articleDto = new ArticleDto();
  private articleUpdateDto = new ArticleUpdateDto();
  private newArticleImage: FileAttachmentDto[] = [];
  private showYn: YN[] = [...CONST_YN];
  private imageChanged = false;

  getLinkUrl(linkUrl: string) {
    return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
  }

  findOne(id) {
    ArticleService.findOne(id).subscribe(res => {
      if (res) {
        this.articleDto = res.data;
      }
    });
  }

  showUpdateModal() {
    this.articleUpdateDto = this.articleDto;
    this.findOne(this.$route.params.id);
  }

  // upload article image
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.ARTICLE, [
        file,
      ]);
      this.newArticleImage = [];
      this.newArticleImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
    }
  }

  removeArticleImage() {
    this.newArticleImage = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  updateArticle() {
    if (this.newArticleImage.length > 0) {
      this.articleUpdateDto.image = this.newArticleImage;
    } else {
      delete this.articleUpdateDto.image;
    }
    ArticleService.update(
      this.$route.params.id,
      this.articleUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  deleteOne() {
    ArticleService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/article');
      }
    });
  }

  created() {
    const id = this.$route.params.id;
    this.findOne(id);
  }
}
